(function() {
  const root = document.querySelector('#desc-accordion');
  if (!root) return;
  if (root.dataset.msAccordionBuilt === '1') return;
  root.dataset.msAccordionBuilt = '1';

  // Hilfsfunktionen für Animation
  function openItem(item) {
    const panel = item.querySelector('.acc-panel');
    const header = item.querySelector('.acc-header');
    if (!panel || !header) return;

    // erst aktuelle Höhe setzen, dann auf die Zielhöhe animieren
    panel.style.paddingBottom = '16px';
    panel.style.maxHeight = panel.scrollHeight + 'px';

    item.setAttribute('open', '');
    header.setAttribute('aria-expanded', 'true');

    // Nach der Transition auf "auto" umstellen, damit sich spätere Inhaltsänderungen anpassen
    const onEnd = (e) => {
      if (e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', onEnd);
      if (item.hasAttribute('open')) {
        panel.style.maxHeight = 'none';
      }
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function closeItem(item) {
    const panel = item.querySelector('.acc-panel');
    const header = item.querySelector('.acc-header');
    if (!panel || !header) return;

    // Von "auto" auf konkrete Höhe setzen, um von dort nach 0 zu animieren
    if (panel.style.maxHeight === 'none' || panel.style.maxHeight === '') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    // animiert zu
    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
      panel.style.paddingBottom = '0px';
    });

    item.removeAttribute('open');
    header.setAttribute('aria-expanded', 'false');
  }

  function insertItemAtHeading(headingEl, nextHeadingEl) {
    // Anker an exakter Stelle setzen
    const anchor = document.createComment('acc-anchor');
    headingEl.parentNode.insertBefore(anchor, headingEl);

    // Inhalte zwischen heading und nächster heading ausschneiden
    const range = document.createRange();
    range.setStartAfter(headingEl);
    if (nextHeadingEl) {
      range.setEndBefore(nextHeadingEl);
    } else {
      range.setEndAfter(root.lastChild);
    }
    const contentFrag = range.extractContents();

    // Akkordeon-Item bauen
    const item = document.createElement('div');
    item.className = 'acc-item';
    item.setAttribute('role', 'group');

    const header = document.createElement('div');
    header.className = 'acc-header';
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');

    headingEl.classList.add('acc-title');
    header.appendChild(headingEl);

    const plus = document.createElement('div');
    plus.className = 'acc-plus';
    plus.textContent = '+';
    header.appendChild(plus);

    const sep = document.createElement('div');
    sep.className = 'acc-sep';

    const panel = document.createElement('div');
    panel.className = 'acc-panel rte';
    panel.appendChild(contentFrag);

    // Toggle: immer nur ein offen + animiert
    function toggle() {
      const isOpen = item.hasAttribute('open');

      // erst alle schließen (animiert)
      root.querySelectorAll('.acc-item[open]').forEach(it => {
        if (it !== item) closeItem(it);
      });

      // dann ggf. diesen öffnen/schließen
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    header.addEventListener('click', toggle);
    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });

    item.appendChild(header);
    item.appendChild(sep);
    item.appendChild(panel);

    // Anker durch Item ersetzen → korrekte Position in der Tiefe
    anchor.parentNode.replaceChild(item, anchor);
  }

  // Headings sammeln und Items bauen
  const headings = root.querySelectorAll('h2, h3');
  if (!headings.length) return;

  headings.forEach((heading, idx) => {
    const next = headings[idx + 1] || null;
    insertItemAtHeading(heading, next);
  });

  // Standard: alle geschlossen lassen (keinen automatisch öffnen)
  // (Falls du wieder den ersten offen starten willst, einfach openItem(root.querySelector('.acc-item')); aufrufen.)
})();

